module.exports = __webpack_public_path__ + "static/media/strawberry-bowl.1e94e88d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/page/parallaxSplit/strawberry-bowl.jpg
// module id = 102
// module chunks = 0